<template>
    <psi-detail-card
        :items="items"
        headingTitle="Profile"
        icon="mdi-card-account-details-outline"
    ></psi-detail-card>
</template>

<script>
export default {
    props: {
        caseDetails: {
            type: Object,
            required: true,
        },
    },
    computed: {
        items() {
            return [
                {
                    text: `${this.caseDetails.address1} ${this.caseDetails.city}, ${this.caseDetails.state} ${this.caseDetails.zip}`,
                    icon: "mdi-map-marker",
                    label: "Address",
                },
                {
                    text: this.caseDetails.dob,
                    icon: "mdi-cake",
                    label: "Birthdate",
                },
                {
                    text: `Height: <span class="font-weight-regular">${this.caseDetails.heightFeet} ft ${this.caseDetails.heightInches} in </span>| Race: <span class="font-weight-regular">${this.caseDetails.race}</span> | Eyes: <span class="font-weight-regular">${this.caseDetails.eyes}</span> | Hair: <span class="font-weight-regular">${this.caseDetails.hair}</span> | Gender: <span class="font-weight-regular">${this.caseDetails.sex}</span>`,
                    icon: "mdi-account",
                    label: "Description",
                },
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
</style>